import React, { useState } from "react";
import { IoIosClose, IoMdCopy, IoMdCheckmark } from "react-icons/io";
import { BsChatRightTextFill } from "react-icons/bs";


export default function SupportModal({
  isModalOpen,
  setModalOpen,
}) {
  const [copyMessage, setCopyMessage] = useState(false);

  const onClose = () => {
    setModalOpen(!isModalOpen);
  };

  const handleCopyEmail = () => {
    navigator.clipboard.writeText("sistemas@amerinode.atlassian.net");
    setCopyMessage(true);
    setTimeout(() => setCopyMessage(false), 2000); // Limpa a mensagem após 2 segundos
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col max-w-[600px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 pt-4 pb-3 text-left gap-2 bg-gray-800 text-white rounded-t-lg">
                <div className="flex gap-2 items-center text-white text-xl font-bold">
                  <BsChatRightTextFill />
                  CONTATO DE SUPORTE
                </div>
                
              </div>

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6 px-12">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col text-sm">
                    <div className="flex flex-col items-center gap-6 mb-4 w-full">
                      <div className="text-gray-700">
                        Nosso canal de suporte é através do email:
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="text-sky-800 font-bold whitespace-nowrap">
                          sistemas@amerinode.atlassian.net
                        </div>
                        <button
                          onClick={handleCopyEmail}
                          className="text-gray-500 hover:text-gray-700"
                        >
                          {copyMessage ? <IoMdCheckmark size={20} /> : <IoMdCopy size={20} />}
                        </button>
                      </div>
                      <div className="text-gray-700 text-xs">
                        *Nos envie o máximo de informações possíveis, como prints, fotos e descrição detalhada do problema.
                      </div>
                    </div>

                    {/* Texto Informativo */}
                    <div className="flex flex-col gap-4 text-gray-700 text-[11px]">
                      <div>
                        <span className="font-bold">Gestão de Atendimentos/Entregas 24x7</span>
                        <ul className="mt-2">
                          <li>Jean (06:00 - 16:00) - <span className="font-bold">11 97957-0488</span></li>
                          <li> ------- (11:30 - 21:00) - <span className="font-bold">11 91173-8939</span></li>
                          <li>Marcio (21:00 - 06:00) - <span className="font-bold">11 95071-9863</span></li>
                        </ul>
                      </div>

                      <div>
                        <span className="font-bold">Rede Móvel</span>
                        <ul className="mt-2">
                          {/* <li>Mariana - <span className="font-bold">11 97378-1841</span> (<span className="text-sky-800">mariana.guilherme@amerinode.com.br</span>)</li> */}
                          <li>Thiago - <span className="font-bold">11 97380-5904</span> (<span className="text-sky-800">thiago.bellon@amerinode.com.br</span>)</li>
                        </ul>
                      </div>

                      <div>
                        <span className="font-bold">Gestão PRIME</span>
                        <ul className="mt-2">
                          <li>Supervisor: Jeferson Rodrigues - <span className="font-bold">11-93081-8494</span> (<span className="text-sky-800">jeferson.rodrigues@amerinode.com.br</span>)</li>
                          <li>Coordenador: Guilherme Alberto - <span className="font-bold">11 93256-6628</span> (<span className="text-sky-800">guilherme.alberto@amerinode.com.br</span>)</li>
                          <li>Gerente: Marcelo Panhoca - <span className="font-bold">11 97400-8800</span> (<span className="text-sky-800">marcelo.panhoca@amerinode.com.br</span>)</li>
                        </ul>
                      </div>

                      <div>
                        <span className="font-bold">Rede Fixa</span> (CX / IE / SDH / B2B / MSAN_ADSL)
                        <ul className="mt-2">
                          <li>Alice - <span className="font-bold">11 93393-3321</span> (<span className="text-sky-800">alice.silva@amerinode.com.br</span>)</li>
                          <li>Claudi  - <span className="font-bold">11 97540-9172</span> (<span className="text-sky-800">claudi.santos@amerinode.com.br</span>)</li>
                        </ul>
                      </div>

                      <div>
                        <span className="font-bold">Backbone</span> (DWDM/IP)
                        <ul className="mt-2">
                          <li>Adriana - <span className="font-bold">11 97259-4369</span> (<span className="text-sky-800">adriana.nascimento@amerinode.com.br</span>)</li>
                          <li>Raiane - <span className="font-bold">11 97557-6803</span> (<span className="text-sky-800">raiane.oliveira@amerinode.com.br</span>)</li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex gap-4 mt-6">
                      <button
                        onClick={() => setModalOpen(!isModalOpen)}
                        className="w-full bg-gray-500 text-white py-2 px-4 rounded-2xl hover:bg-gray-600"
                      >
                        Fechar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}